export const ACCOUNT_LIFECYCLE_STATES = [
  'active',
  'deactivated',
  'suspended',
  'deletion_pending',
  'deleted',
  'memorialized',
] as const;

export type AccountLifecycleState = (typeof ACCOUNT_LIFECYCLE_STATES)[number];

export const ACCOUNT_DELETION_RETENTION_DAYS = 30;

export type AccountLifecycleRecord = {
  user_id: string;
  state: AccountLifecycleState;
  state_version: number;
  resume_state: 'active' | 'deactivated' | null;
  state_changed_at: string;
  deletion_requested_at: string | null;
  deletion_scheduled_for: string | null;
  deletion_canceled_at: string | null;
  deleted_at: string | null;
  memorialized_at: string | null;
};

export function isAccountLifecycleState(value: unknown): value is AccountLifecycleState {
  return (
    typeof value === 'string' &&
    (ACCOUNT_LIFECYCLE_STATES as readonly string[]).includes(value)
  );
}

export function accountAllowsNormalAccess(state: AccountLifecycleState | null | undefined) {
  return !state || state === 'active';
}

export function accountAllowsSelfReactivation(state: AccountLifecycleState) {
  return state === 'deactivated' || state === 'deletion_pending';
}

export function deletionScheduledFor(now = new Date()): string {
  const scheduled = new Date(now);
  scheduled.setUTCDate(scheduled.getUTCDate() + ACCOUNT_DELETION_RETENTION_DAYS);
  return scheduled.toISOString();
}

export function lifecyclePubliclyEligible(
  state: AccountLifecycleState,
  profileEnabled: boolean
) {
  return state === 'active' && profileEnabled;
}
